import React from "react";
import { motion } from "framer-motion";

const REQUEST_LINES = [
  { text: "$ curl -H \"X-API-Key: lp_live_••••\" \\", cls: "text-white/80" },
  { text: "       https://loftpress.shop/api/v1/currency/convert?base=USD&to=EUR&amount=1250", cls: "text-white/70" },
];
const RESPONSE_LINES = [
  { text: "HTTP/2 200 · 128ms · req_1a2b3c", cls: "text-emerald-400/80" },
  { text: "{", cls: "text-white/70" },
  { text: "  \"success\": true,", cls: "text-white/70" },
  { text: "  \"data\": {", cls: "text-white/70" },
  { text: "    \"base\": \"USD\", \"to\": \"EUR\",", cls: "text-white/70" },
  { text: "    \"amount\": 1250, \"rate\": 0.925,", cls: "text-white/70" },
  { text: "    \"result\": 1156.25", cls: "text-[#d4af37]" },
  { text: "  },", cls: "text-white/70" },
  { text: "  \"credits_remaining\": 99992,", cls: "text-white/70" },
  { text: "  \"cached\": false", cls: "text-white/70" },
  { text: "}", cls: "text-white/70" },
];

function Typed({ lines, speed = 22, startDelay = 0 }) {
  const [visible, setVisible] = React.useState([]);

  React.useEffect(() => {
    let cancelled = false;
    let idx = 0;
    let charIdx = 0;
    let acc = [];

    const tick = () => {
      if (cancelled) return;
      if (idx >= lines.length) return;
      const line = lines[idx];
      charIdx++;
      const chunk = line.text.slice(0, charIdx);
      acc = [...acc.slice(0, idx), { ...line, text: chunk }];
      setVisible([...acc]);
      if (charIdx >= line.text.length) {
        idx++;
        charIdx = 0;
        setTimeout(tick, 90);
      } else {
        setTimeout(tick, speed);
      }
    };

    const t = setTimeout(tick, startDelay);
    return () => {
      cancelled = true;
      clearTimeout(t);
    };
  }, [lines, speed, startDelay]);

  return (
    <div className="font-mono text-[13px] leading-6 whitespace-pre">
      {visible.map((l, i) => (
        <div key={i} className={l.cls}>{l.text}</div>
      ))}
    </div>
  );
}

export default function ApiRequestDemo() {
  const [phase, setPhase] = React.useState("request");

  React.useEffect(() => {
    const t1 = setTimeout(() => setPhase("response"), 2400);
    const t2 = setInterval(() => {
      setPhase("request");
      setTimeout(() => setPhase("response"), 2400);
    }, 9000);
    return () => {
      clearTimeout(t1);
      clearInterval(t2);
    };
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      className="lp-terminal shadow-2xl shadow-[#d4af37]/5"
      data-testid="api-demo-terminal"
    >
      <div className="lp-terminal-header">
        <div className="flex items-center gap-1.5">
          <div className="lp-terminal-dot bg-[#ff5f57]"></div>
          <div className="lp-terminal-dot bg-[#febc2e]"></div>
          <div className="lp-terminal-dot bg-[#28c840]"></div>
        </div>
        <span className="text-xs text-white/40 font-mono ml-2">terminal — loftpress.shop</span>
        <span className="ml-auto lp-chip green text-[10px]">live</span>
      </div>
      <div className="p-5 min-h-[280px]">
        <Typed key="req" lines={REQUEST_LINES} speed={16} />
        {phase === "response" && (
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35 }}
            className="mt-4"
          >
            <Typed key={`res-${phase}`} lines={RESPONSE_LINES} speed={12} />
          </motion.div>
        )}
      </div>
    </motion.div>
  );
}
